import React from "react";
import { SEO } from "@/components/SEO";
import { Reveal, RevealText } from "@/components/brand/Reveal";
import { BrandCard } from "@/components/brand/BrandCard";
import { Link } from "react-router-dom";
import { SITE_NAME, SITE_URL } from "@/content/siteConfig";

const claims = [
  {
    title: "No INTERNET permission.",
    body: "CrenelView cannot send anything anywhere, whatever anyone claims. Anyone can check this in the Play listing's permission list.",
  },
  {
    title: "No account, no sign in.",
    body: "Nothing to create, nothing to leak.",
  },
  {
    title: "No server.",
    body: "Nothing is stored off your phone, because there is nowhere to store it.",
  },
  {
    title: "No usage reports and no screen time figures.",
    body: "Measuring that would need a permission the app deliberately does not request.",
  },
  {
    title: "The installed app list stays on the phone.",
    body: "It is read on your phone only, to show you what you can block. It is never transmitted.",
  },
];

export default function Privacy() {
  return (
    <>
      <SEO
        title={`Privacy - ${SITE_NAME}`}
        description="No INTERNET permission, no account, no server, no usage reports. Concrete facts about what CrenelView does and does not do."
        path="/privacy"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: `Privacy - ${SITE_NAME}`,
          url: `${SITE_URL}/privacy`,
        }}
      />

      <section className="mx-auto max-w-4xl px-6 pt-14 pb-10 sm:pt-20">
        <RevealText lines={["Privacy, in plain terms."]} className="font-heading text-4xl sm:text-5xl lg:text-6xl" as="h1" />
        <Reveal delay={0.3}>
          <p className="mt-6 max-w-xl text-base text-cvbody sm:text-lg">
            Not a promise. A list of what the app actually does, and does not do.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-5xl px-6 pb-16 sm:pb-20">
        <div className="grid gap-5 sm:grid-cols-2">
          {claims.map((claim, i) => (
            <Reveal key={claim.title} delay={Math.min(i * 0.03, 0.1)}>
              <BrandCard className="h-full">
                <h3 className="font-heading text-xl">{claim.title}</h3>
                <p className="mt-3 text-base text-cvbody">{claim.body}</p>
              </BrandCard>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-6 pb-20 sm:pb-28">
        <Reveal>
          <p className="text-base text-cvbody">
            If a future version of CrenelView ever changes any of this, this page changes first.{" "}
            <Link to="/privacy-policy" className="text-cvlink underline" data-testid="privacy-to-policy-link">
              Read the full Privacy Policy
            </Link>
            .
          </p>
        </Reveal>
      </section>
    </>
  );
}
